import { FC } from "react"
import { useElements, useStripe } from "@stripe/react-stripe-js"
import { Aside } from "./Aside"

interface AsideInsideElementsProps {
	clientSecret?: string
	stripeComplete: boolean,
}

export const AsideInsideElements:FC<AsideInsideElementsProps> = ({stripeComplete, clientSecret}) => {

    const stripe = useStripe()
    const elements = useElements()

    return (
        <Aside stripe={stripe} elements={elements} stripeComplete={stripeComplete} clientSecret={clientSecret} />
    )
}